import { StarOutlineIcon } from '@gogame/ui/Icon';
import Rating from '@gogame/ui/Rating';

const CommentRating = ({ mark }) => (
  <Rating
    data-cy={'MessageRating'}
    value={mark}
    readOnly
    emptyIcon={<StarOutlineIcon sx={{ fontSize: 18 }} />}
  />
);

export default CommentRating;
